module.exports = {"450521100":"廉州镇","450521101":"党江镇","450521102":"西场镇","450521103":"沙岗镇","450521104":"乌家镇","450521105":"闸口镇","450521106":"公馆镇","450521107":"白沙镇","450521108":"山口镇","450521109":"沙田镇","450521110":"石湾镇","450521111":"石康镇","450521112":"常乐镇","450521113":"星岛湖镇","450521200":"曲樟乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450521.json
// module id = 2247
// module chunks = 0